module.exports = __webpack_public_path__ + "static/media/Gianna Whitver Headshot.1b36db95.jpeg";